import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useDebounce } from "../../../hooks/useDebounce";
import { transactionFieldLabels, transactionsExcelFormFields } from "../../../lib/constants";
import { useGetTransactionList } from "../../../lib/queries/queriesAndMutations";
import { unixToPersianDay, unixToPersianTime } from "../../../utils/utils";
import CopyButton from "../../shared/CopyButton";
import Loader from "../../shared/Loader";
import Pagination from "../../shared/Pagination";
import SettlmentTextBtn from "../../shared/SettlmentTooltipBtn/SettlmentTextBtn";
import TableLoader from "../../shared/TableLoader";
import TrasnactionCard from "../transaction/TrasnactionCard";
import AdvanceSearchBtn from "./PopupBtns/AdvanceSearchBtn";
import ExcelPopupBtn from "./PopupBtns/ExcelPopupBtn";
import FilterDetailBar from "./PopupBtns/FilterDetailBar";

const PosTransactionsList = () => {
  const navigate = useNavigate();
  const type = useSelector((store) => store.bussinessSlice.type);
  const businessId = useSelector((store) => store.bussinessSlice?.data?.business?.id);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;
  const [searchTerm, setSearchTerm] = useState({
    transaction_type: "pos",
    transaction_state: "",
    settlement_status: "",
    from_payment_time: "",
    to_payment_time: "",
    from_amount: "",
    to_amount: "",
    exact_amount: "",
    invoice_number: "",
    payer_name: "",
    payer_mail: "",
    payer_mobile: "",
    gateway_id: "",
    form_id: "",
    user_id: "",
    reference_number: "",
    track_id: "",
    card_number: "",
    user_fullname: "",
    vanda_tracking_code: "",
    order_by: "invoice_time",
    descending: true,
  });

  const debouncedSearchTerm = useDebounce(searchTerm, 100);

  const onPageChange = (page) => setCurrentPage(page);

  const {
    data: transactionList,
    isPending,
    refetch,
    isRefetching,
    isError,
  } = useGetTransactionList({
    type,
    businessId,
    searchTerm: debouncedSearchTerm,
    currentPage,
    pageSize,
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearchTerm]);

  useEffect(() => {
    refetch();
  }, [debouncedSearchTerm, currentPage, refetch]);

  if (isPending) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }
  if (isRefetching) {
    return (
      <div className="w-full h-full flex-center min-h-[400px] ">
        <Loader />
      </div>
    );
  }
  if (isError) {
    return <div className="w-full h-full flex-center min-h-[400px] ">خطا در سرور</div>;
  }

  return (
    <div className="  rounded-v-lg p-2 relative flex flex-col overflow-hidden  w-full pb-10">
      <div className="flex gap-2 justify-between w-full ">
        {/* Use memoized options and callback for HeaderSelect */}

        <div className="flex gap-2">
          <ExcelPopupBtn
            searchTermRef={debouncedSearchTerm}
            fields={transactionsExcelFormFields}
            url={"transactions"}
            type={type}
            businessId={businessId}
          />
          <AdvanceSearchBtn setSearchTerm={setSearchTerm} />
        </div>
      </div>
      <FilterDetailBar
        searchTerm={debouncedSearchTerm}
        setSearchTerm={setSearchTerm}
        labelFields={transactionFieldLabels}
      />

      <div className=" overflow-scroll no-scrollbar hidden md:block">
        <table className="w-full" id="albums" cellSpacing="1">
          <thead>
            <tr>
              <th scope="col">تاریخ پرداخت</th>
              <th scope="col"> مبلغ</th>
              <th scope="col"> نام ترمینال </th>
              <th scope="col">شماره پیگیری وندا</th>
              <th scope="col"> وضعیت تراکنش </th>
              <th scope="col"> وضعیت تسویه </th>
            </tr>
          </thead>
          <tbody>
            {isRefetching ? (
              <TableLoader />
            ) : (
              transactionList?.items.map((item, index) => (
                <tr
                  onClick={() => navigate(`/transaction/info/${item.transaction.vanda_tracking_code}`)}
                  key={index}
                  className="p-2 bg-neutral-20 gap-2 cursor-pointer hover:bg-neutral-30"
                >
                  <td className="text-center align-middle min-w-[120px]">
                    <div>{unixToPersianDay(item?.transaction?.invoice_time ?? "-")}</div>
                    <div>{unixToPersianTime(item?.transaction?.invoice_time) ?? "-"}</div>
                  </td>
                  <td className="text-center">{item?.transaction?.amount.toLocaleString() ?? "-"}</td>

                  <td dir="ltr" className="email max-w-[200px]  truncate text-center " title={item?.title}>
                    {item?.title}
                  </td>

                  {/* <td
                     dir="ltr"
                     className="email min-w-[100px]  truncate text-center "
                     title={item.business?.fa_name}
                   >
                     {item.business?.fa_name ?? "-"}
                   </td> */}

                  <td className="text-center   align-middle min-w-[180px] ">
                    <div className="flex-center gap-1 mx-auto b">
                      {item.transaction.vanda_tracking_code ?? "-"}
                      <CopyButton copyText={item.transaction.vanda_tracking_code ?? "-"} />
                    </div>
                  </td>

                  <td className="text-center align-middle  ">
                    <TransactionState value={item.transaction.transaction_state} />
                  </td>
                  <td className="text-center align-middle  ">
                    <SettlmentTextBtn value={item.transaction.settlement_status} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="w-full bg-neutral-20 p-2 grid grid-cols-1  lg:grid-cols-2 2xl:grid-cols-3 3xl:grid-cols-4 gap-4 md:p-2 rounded-[16px]  md:hidden  ">
        {transactionList?.count > 0 ? (
          transactionList?.items.map((item, index) => (
            <TrasnactionCard key={index} item={item} navigate={navigate} refetch={refetch} />
          ))
        ) : (
          <p>آیتمی وجود ندارد ...</p>
        )}
      </div>
      <div className="w-full  rounded-v-lg bg-neutral-00 mx-auto  sticky bottom-0 left-0 ">
        <Pagination
          onPageChange={onPageChange}
          totalCount={transactionList?.count || 0}
          siblingCount={1}
          currentPage={currentPage}
          pageSize={pageSize}
          className=""
        />
      </div>
    </div>
  );
};

export default PosTransactionsList;

const TransactionState = ({ value }) => {
  const [showTooltip, setShowTooltip] = useState(true);

  const options = [
    {
      value: "success",
      label: "موفق",
      class: "text-success-60 bg-success-10 rounded-md px-[10px] py-1",
    },
    {
      value: "failed",
      label: "ناموفق",
      class: "text-error-90 bg-error-20 rounded-md px-[10px] py-1",
    },
    {
      value: "in_progress",
      label: "درحال انجام",
      class: "text-secondary-90 bg-[#CED3D9] rounded-md px-[10px] py-1 min-w-[100px]",
    },
  ];

  const item = options.find((entry) => entry.value === value);
  const label = item ? item.label : "*";
  const className = item ? item.class : "*";

  return <div className={className}>{label}</div>;
};
